const ProductCostingType = {
  GET_TESTING_BOM_LIST: 'GET_TESTING_BOM_LIST',
  MAEK_AS_COMPLETE: 'MAEK_AS_COMPLETE',
  ADD_PRODUCT_COSTING_DATA: 'ADD_PRODUCT_COSTING_DATA',
  LIST_PRODUCT_COSTING: 'LIST_PRODUCT_COSTING',
  SET_PRODUCT_COSTING_DETAIL_BY_ID: 'SET_PRODUCT_COSTING_DETAIL_BY_ID',
  REMOVE_PRODUCT_COSTING: 'REMOVE_PRODUCT_COSTING',
  PRODUCT_COSTING_UNMOUNT: 'PRODUCT_COSTING_UNMOUNT',
  DUPLICATE_PRODUCT_COSTING_DETAIL: 'DUPLICATE_PRODUCT_COSTING_DETAIL',
  SELECT_ALL_PRODUCT: 'SELECT_ALL_PRODUCT',
  LIST_PRODUCT_COSTING_COMMENT: 'LIST_PRODUCT_COSTING_COMMENT',
  SET_DATA_TO_UPDATE_COMMENT: 'SET_DATA_TO_UPDATE_COMMENT',
  UPDATE_COSTING_COMMENT: 'UPDATE_COSTING_COMMENT',
  SET_PRODUCT_COLOUR: 'SET_PRODUCT_COLOUR',
  SET_PRODUCT_LENGTHS: 'SET_PRODUCT_LENGTHS',
  SET_PRODUCT_SIZES: 'SET_PRODUCT_SIZES',
  SET_FILTER_SORT_DATA: 'SET_FILTER_SORT_DATA',
  SET_UNINTEGRATED_COLOURWAYS: 'SET_UNINTEGRATED_COLOURWAYS',
  SET_UNINTEGRATED_UNITS: 'SET_UNINTEGRATED_UNITS',
  SET_UNINTEGRATED_PRODUCT_COSTING_DETAILS: 'SET_UNINTEGRATED_PRODUCT_COSTING_DETAILS',
  SET_CLEARED_HIGHLIGHTS_STATUS: 'SET_CLEARED_HIGHLIGHTS_STATUS',
  SET_REFRESHED_STATE: 'SET_REFRESHED_STATE',
  SET_PRODUCT_COSTING_EXCHANGE_RATE: 'SET_PRODUCT_COSTING_EXCHANGE_RATE',
  SET_PRODUCT_COSTING_TEMPLATE_DETAIL_BY_ID: 'SET_PRODUCT_COSTING_TEMPLATE_DETAIL_BY_ID',
  SET_UNINTEGRATED_COSTINGSTAGE: 'SET_UNINTEGRATED_COSTINGSTAGE',
};
export default ProductCostingType;
